<!-- <div class="page-layout" *ngIf="(isAuth0Loading$ | async) || isLoadingUserData; else auth0Loaded">
  <page-loader></page-loader>
</div>
<ng-template #auth0Loaded>
  <router-outlet></router-outlet>
</ng-template> -->


<router-outlet></router-outlet>